import { render, staticRenderFns } from "./ProfileStreams.vue?vue&type=template&id=543fd054&"
import script from "./ProfileStreams.vue?vue&type=script&lang=js&"
export * from "./ProfileStreams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports